/*
  Enigma Store — Extras Cyber (cargado desde layout/theme.liquid)
  Mejoras de portada sin tocar custom.js.
*/

/* ══ Colecciones destacadas (movil): pista de deslizamiento ══ */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 767.98px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  var EASE = 'cubic-bezier(0.23, 1, 0.32, 1)';
  function nudge(list) {
    if (list.dataset.enigmaNudged || !mq.matches || reduce.matches) return;
    if (list.scrollWidth <= list.clientWidth + 8) return;
    list.dataset.enigmaNudged = '1';
    var dir = document.documentElement.getAttribute('dir') === 'rtl' ? 1 : -1;
    var dist = Math.min(56, Math.round(list.clientWidth * 0.14)) * dir;
    var anim = list.animate([
      { transform: 'translateX(0)' },
      { transform: 'translateX(' + dist + 'px)', offset: 0.42 },
      { transform: 'translateX(' + Math.round(dist * -0.08) + 'px)', offset: 0.78 },
      { transform: 'translateX(0)' }
    ], { duration: 1300, delay: 450, easing: EASE });
    var cancel = function () { try { anim.cancel(); } catch (e) {} };
    list.addEventListener('touchstart', cancel, { once: true, passive: true });
    list.addEventListener('pointerdown', cancel, { once: true });
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && e.intersectionRatio >= 0.5) { nudge(e.target); io.unobserve(e.target); }
    });
  }, { threshold: [0.5] });
  function init() {
    document.querySelectorAll('.featured-collections .collection-list').forEach(function (list) {
      if (list.dataset.enigmaNudgeObs) return;
      list.dataset.enigmaNudgeObs = '1';
      io.observe(list);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();


/* ══ Featured Products con pestanas: montar el carrusel de cada pestana ══ */
(function () {
  function opts(d) {
    return {
      drag: true,
      arrows: d.arrows === 'true',
      pagination: d.pagination === 'true',
      easing: d.easing,
      speed: Number(d.speed) || 400,
      perMove: Number(d.perMove) || 0,
      autoplay: d.autoplay === 'true',
      interval: Number(d.interval) || 5000,
      rewind: d.rewind === 'true',
      mediaQuery: 'min',
      breakpoints: {
        0: { perPage: Number(d.breakpointXs) || 1, padding: d.breakpointXsPartial === 'true' ? { right: '16%' } : 0 },
        576: { perPage: Number(d.breakpointSm) || 2, padding: 0 },
        768: { perPage: Number(d.breakpointMd) || 2, padding: 0 },
        992: { perPage: Number(d.breakpointLg) || 3, padding: 0 },
        1200: { perPage: Number(d.breakpointXl) || 4, padding: 0 },
        1400: { perPage: Number(d.breakpointXxl) || 4, padding: 0 }
      },
      direction: document.documentElement.getAttribute('dir') || 'ltr'
    };
  }
  function fixArrows(el) {
    var img = el.querySelector('.product-item-img');
    if (!img) return;
    var top = img.clientHeight / 2;
    el.querySelectorAll('.splide__arrow').forEach(function (a) { a.style.top = top + 'px'; });
  }
  function showPane(pane) {
    if (!pane) return;
    var el = pane.querySelector('.splide');
    if (!el) return;
    if (el.__enigmaSplide) { try { el.__enigmaSplide.refresh(); } catch (e) {} fixArrows(el); return; }
    if (el.classList.contains('is-initialized')) { window.dispatchEvent(new Event('resize')); return; }
    if (typeof window.Splide !== 'function') return;
    try {
      var s = new window.Splide(el, opts(el.dataset));
      s.on('ready resize', function () { fixArrows(el); });
      s.mount();
      el.__enigmaSplide = s;
    } catch (err) {
      el.style.visibility = 'visible';
      if (window.console) console.warn('Enigma featured tabs:', err);
    }
  }
  function paneFor(btn) {
    var sel = btn.getAttribute('data-bs-target') || btn.getAttribute('href');
    if (!sel || sel.charAt(0) !== '#') return null;
    return document.getElementById(sel.slice(1));
  }
  document.addEventListener('shown.bs.tab', function (e) {
    var btn = e.target;
    if (!btn || !btn.closest || !btn.closest('.featured-products')) return;
    showPane(paneFor(btn));
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.featured-products [data-bs-toggle="tab"]');
    if (!btn) return;
    var pane = paneFor(btn);
    setTimeout(function () { showPane(pane); }, 60);
    setTimeout(function () { showPane(pane); }, 400);
  });
})();


/* ══ Featured Products — pulido movil (<= 767px) ══ */
(function () {
  if (document.getElementById('enigma-fp-mobile')) return;
  var P = '.featured-products';
  var css = [
    '@media (max-width: 767.98px){',
    P + ' .featured-products-nav{flex-wrap:nowrap!important;overflow-x:auto;overflow-y:hidden;scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;padding-bottom:0!important;margin-bottom:14px!important;justify-content:flex-start!important;-webkit-mask-image:linear-gradient(90deg,#000 88%,transparent);mask-image:linear-gradient(90deg,#000 88%,transparent)}',
    P + ' .featured-products-nav::-webkit-scrollbar{display:none;height:0}',
    P + ' .featured-products-nav .nav-item{flex:0 0 auto}',
    P + ' .featured-products-nav .nav-link{white-space:nowrap;padding:.55rem .8rem;font-size:14px}',
    '}',
    '@media (max-width: 575.98px){',
    P + ' .product-item{padding:0 5px!important;margin-bottom:0!important}',
    P + ' .product-item > div{display:flex;flex-direction:column;height:100%}',
    P + ' .product-item > div > div:last-child{display:flex;flex-direction:column;flex:1 1 auto}',
    P + ' .product-item .img-wrapper{margin-bottom:10px!important}',
    P + ' .product-item .img-badge-sale,' + P + ' .product-item .img-badge-sold-out{font-size:10px!important;padding:3px 6px!important;line-height:1.2}',
    P + ' .product-item-title{font-size:14px!important;line-height:1.3!important;margin-bottom:6px!important;display:-webkit-box!important;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;white-space:normal!important;min-height:2.6em}',
    P + ' .product-item .wsc-proof + *{font-size:11px!important;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;margin-bottom:4px}',
    P + ' .product-item .wsc-proof + * svg,' + P + ' .product-item .wsc-proof + * .jdgm-star{width:11px!important;height:11px!important;font-size:11px!important}',
    P + ' .product-item-price{font-size:13px!important;margin-bottom:6px!important;display:flex;flex-wrap:wrap;align-items:baseline;gap:0 6px}',
    P + ' .product-item-price-compare{margin:0!important;font-size:12px}',
    P + ' .product-item-price-final{font-weight:600}',
    P + ' .product-item-low-stock{font-size:11px!important;margin-bottom:6px!important}',
    P + ' .product-item .mb-2:has(.product-item-form){margin-top:auto;margin-bottom:0!important}',
    P + ' .product-item .btn-atc{font-size:12px!important;letter-spacing:0!important;padding:.6rem .5rem!important;min-height:40px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border-radius:999px;line-height:1.2}',
    P + ' .product-item .btn-atc.dropdown-toggle::after{display:none}',
    P + ' .splide__pagination{margin-top:10px}',
    '}'
  ].join('\n');
  var s = document.createElement('style');
  s.id = 'enigma-fp-mobile';
  s.textContent = css;
  document.head.appendChild(s);
})();
